import React from 'react';
import styled from 'styled-components';

import {buildInteractionIdProps} from '../../../../libs/shared/helpers/src/interaction/interactionHelpers';
import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {helpCenterUrl} from '../../../store/stateless/navigationActions';
import {ReportNavigationHelpLink} from './reportNavigationHelpLink';

/*
 * Styles.
 */

const StyledNavigationHelpWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 20px;

  &:first-child {
    margin-top: 4px;
  }
`;

const StyledTitleWrapper = styled.div<{$headerColor: string}>`
  padding: 6px 8px 6px 14px;
  min-width: 0;

  line-height: normal;
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.semibold};

  ${ellipsis()};

  color: ${(p) => p.$headerColor};
`;

/*
 * Component.
 */

const interactionId = 'analytics-support';
const interactionProps = buildInteractionIdProps(interactionId);

const helpLinks = [
  {
    name: <Trans id="analytics-support-glossary">Glossary</Trans>,
    iconName: 'glossaryLineSmall',
    linkUrl: `${helpCenterUrl}/category/analytics-glossary`,
    interactionProps,
  },
  {
    name: <Trans id="analytics-support-help">Help</Trans>,
    iconName: 'helpSmall',
    linkUrl: `${helpCenterUrl}/t/p8hz4m4/understanding-analytics`,
    interactionProps: undefined,
  },
] as const;

export const ReportNavigationHelpLinks = () => {
  const theme = useUserTheme();

  return (
    <StyledNavigationHelpWrapper>
      <StyledTitleWrapper $headerColor={theme.header}>
        <Trans id="analytics-support-title">Support</Trans>
      </StyledTitleWrapper>
      {helpLinks.map((helpLink) => (
        <ReportNavigationHelpLink
          key={helpLink.iconName}
          iconName={helpLink.iconName}
          name={helpLink.name}
          linkUrl={helpLink.linkUrl}
          interactionProps={helpLink.interactionProps}
        />
      ))}
    </StyledNavigationHelpWrapper>
  );
};
